module.exports = __webpack_public_path__ + "img/revu.00c0bb4c.png";